/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Flex, Spacer } from "@chakra-ui/react";
import environment from "constants/apiConst";
import { ButtonItemsForm } from "pages/Pass-Form/stylePases";
import { useSelector } from "react-redux";
import { __ObtenerQrForm } from "request/Forms/_CrudForm";

/* Deprecated -> ModalQR instead */

export const QrForms = ({ onClose }) => {
  const [qrForms, setQrForms] = useState("");
  const token = useSelector((state) => state.auth.dataUser.token);

  useEffect(() => {
    obtenerQr();
  }, []);

  const obtenerQr = async () => {
    const URLactual = window.location.href;
    const data = {
      url: URLactual
    };
    try {
      const res = await __ObtenerQrForm(environment.GENERATE_QR, token, data);
      setQrForms(res?.data?.status?.data);
    } catch (error) {}
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <img style={{ width: `50%` }} alt="" src={qrForms} />
      </div>

      <Flex mt={6}>
        <Spacer />
        <ButtonItemsForm color="grisaso" onClick={onClose}>
          Cancelar
        </ButtonItemsForm>
      </Flex>
    </>
  );
};
